import React from 'react';
import { MdLock, MdPublic } from 'react-icons/md';

import { UserList } from '../../types/types';

interface PropTypes {
  onClick?: React.MouseEventHandler<HTMLDivElement> | undefined;
  data: UserList;
  className?: string;
}

const UserListBasicItem = ({ data, onClick, className }: PropTypes) => {
  return (
    <div
      className={`flex flex-row rounded-md bg-black cursor-pointer p-2 hover:opacity-[0.4] ${className}`}
      onClick={onClick}
    >
      {data.thumbnail?.file_path ? (
        <img
          className="w-[80px] h-[44.94px] rounded-md"
          width="80px"
          src={`https://cdn-proxy.trakio.app/t/p/w300${data.thumbnail?.file_path}`}
        />
      ) : (
        <img
          className="w-[80px] h-[44.94px] rounded-md"
          src="/assets/app/wallpaper-fallback.jpg"
        />
      )}

      <div className="flex flex-col rounded-md ml-2">
        <span className="text-white text-center font-bold">{data.name}</span>
        {data.privacy === 'private' && <MdLock />}
        {data.privacy === 'public' && <MdPublic />}
      </div>
    </div>
  );
};

export default UserListBasicItem;
